import React from 'react';
import Button from "../../../../form/Button";
import PhoneIcon from "../../../../../assets/image/feature.png";
import Image from "../../../../elements/Image";

const HomeFeature = () => {
  return (
    <section className="relative">
      <div className="w-full max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto">
        <div className="flex items-center gap-10 justify-between relative pt-36 pb-28">
          <div className="max-w-[600px] 2xl:max-w-[760px]">
            <span className="font-Poppins font-semibold text-xl text-primary uppercase">OUR FEATURE</span>
            <h2 className="text-white font-Poppins font-semibold text-4xl 2xl:text-5xl mt-4 leading-[50px] 2xl:leading-[60px]">Track short-term changes and long-term patterns</h2>
            <div className="text-white text-lg 2xl:text-xl mt-9 mb-7 leading-[36px]">
               <p>Top up your cryptocurrency account and start trading today—choose from several payment options. Enjoy a seamless funding experience with secure transactions, fast processing times, and full support for credit cards, bank transfers, and digital wallets.</p>
            </div>
            <Button
              buttonLabel={"Buy Crypto"}
              buttonClasses={"!px-3 md:!px-7 !rounded-lg"}
              buttonLabelClasses={"!text-xs md:!text-[18px] whitespace-nowrap uppercase font-semibold text-white font-Inter"}
            />
          </div>
          <div className="max-w-[570px] 2xl:max-w-[670px] relative z-[1]">
            <div className="overflow-hidden w-full">
              <Image src={PhoneIcon} alt={""} classes={"object-cover"} />
            </div>
          </div>
          <div className="absolute m-auto w-[400px] 2xl:w-[700px] h-[400px] 2xl:h-[700px] rounded-full bg-radial-custom z-0 right-0"></div>
        </div>
      </div>
    </section>
  );
};

export default HomeFeature;